import React, { memo } from 'react';
import { Button, ButtonColor } from '@pegasus/ui-components/components/button';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import Translate from '@client/components/shared/translation/Translate';
import HappyFace from '@client/components/shared/faces/HappyFace';
import MessageTile from '../message-tile';
import { MessageWrapper } from './ResetPasswordSuccess.styles';

interface ResetPasswordSuccessProps {
    onClose: () => void;
}
const ResetPasswordSuccess = memo(({ onClose }: ResetPasswordSuccessProps) => {
    return (
        <TranslationsScope path="resetPasswordSuccess">
            <MessageWrapper>
                <MessageTile
                    icon={() => <HappyFace />}
                    title={<Translate message="title" />}
                    message={<Translate message="message" />}
                />
            </MessageWrapper>
            <Button fullWidth color={ButtonColor.dark} onClick={onClose}>
                <Translate message="cta" />
            </Button>
        </TranslationsScope>
    );
});

export default ResetPasswordSuccess;
